export const NEW_LABEL_DESCRIPTION = 'Create new label';
